type Option = {
  readonly label: string;
  readonly value: string;
};

type Formatters = {
  toDisplayValue: (_: string | undefined) => Option[];
  toFormDataValue: (_: Readonly<Option[]> | undefined) => string | undefined;
};

const asinStringToAsinOptions = (asinStr: string | undefined): Option[] => {
  if (!asinStr) return [];
  const asinList = JSON.parse(asinStr);
  return asinList.map((v: string) => ({
    label: v[0],
    value: v[0],
  }));
};

const asinOptionsToString = (asinOptions: Readonly<Option[]> | undefined) => {
  const values = asinOptions
    ? asinOptions.map((opt: Option) => [
        opt.value,
      ])
    : [];
  return values.length > 0 ? JSON.stringify(values) : undefined;
};

const stringToOptionsList = (str: string | undefined): Option[] =>
  str
    ? str.split(',').map((v: string) => ({
        label: v,
        value: v,
      }))
    : [];

const optionsListToString = (options: Readonly<Option[]> | undefined) => {
  const values = options ? options.map((opt: Option) => opt.value) : [];
  return values.length > 0 ? values.join(',') : undefined;
};

export const selectFormatterRegistry: Record<string, Formatters> = {
  asinFormatters: {
    toDisplayValue: asinStringToAsinOptions,
    toFormDataValue: asinOptionsToString,
  },
  stringListFormatters: {
    toDisplayValue: stringToOptionsList,
    toFormDataValue: optionsListToString,
  },
};
